import { createContext } from 'react';

import {
  OrganizationConfiguration,
  RequestRemoteAccessBuildingConfigurationUpdate,
  RequestRemoteAccessOrganizationConfigurationUpdate,
} from '@totem/components/services/remoteAccess/auditConfiguration/types';

type RemoteAccessAuditConfigurationContextProps = {
  config: OrganizationConfiguration | null;
  loading: boolean;
  canView: boolean;
  isSending: boolean;
  onRefresh?: () => void;
  onUpdateOrganization?: (
    payload: RequestRemoteAccessOrganizationConfigurationUpdate,
  ) => Promise<boolean>;
  onUpdateBuilding?: (
    payload: RequestRemoteAccessBuildingConfigurationUpdate,
  ) => Promise<boolean>;
};

const RemoteAccessAuditConfigurationContext =
  createContext<RemoteAccessAuditConfigurationContextProps>({
    config: null,
    loading: false,
    canView: false,
    isSending: false,
    onRefresh: null,
    onUpdateOrganization: null,
    onUpdateBuilding: null,
  });

export default RemoteAccessAuditConfigurationContext;
